module.exports = __webpack_public_path__ + "fcdd9a6995a3b0a42b1f189b1adedece.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg18.jpeg
// module id = 26
// module chunks = 0